import styled, { keyframes } from 'styled-components';

const Container = {
  backgroundColor: '#14C1DF',
  color: '#ffffff',
  borderRadius: '5px',
  width: '100%',
  border: 'none',
  padding: '12px',
  fontSize: '1rem',
  cursor: 'pointer',
};

const SpinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const MainButton = styled.button`
  ${Container}
`;

const Loading = styled.div`
  ${Container};
  width: auto;
  display: flex;
  justify-content: center;
  cursor: not-allowed;

  > svg {
    animation: ${SpinAnimation} 3s linear infinite;
  }
`;

const BtnWithLoadStyle = {
  MainButton,
  Loading,
};

export default BtnWithLoadStyle;
